"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExp = void 0;
exports.escapeRegexpSpecialCharacters = escapeRegexpSpecialCharacters;
const special_characters_regexp_1 = require("../special-characters.regexp");
/**
 * Экранирует спецсимволы которые могут использоваться в регулярках
 * Такой функционал может понадобиться если у вас есть рандомная строка, которую нужно превратить в регулярку
 */
function escapeRegexpSpecialCharacters(string) {
    string = '' + string;
    return string && special_characters_regexp_1.REGEXP_SPECIAL_CHARACTERS.test(string) ? string.replace(special_characters_regexp_1.REGEXP_SPECIAL_CHARACTERS, '\\$&') : string;
}
/**
 * @deprecated Используйте escapeRegexpSpecialCharacters
 */
exports.escapeRegExp = escapeRegexpSpecialCharacters;
//# sourceMappingURL=escape-regexp-special-characters.util.js.map